import { gql } from '@apollo/client';
import { FragReviewListItem } from './frag-review-list-item';

export const REVIEW_LIST = gql`
  ${FragReviewListItem}

  query ReviewList($id: BigInt!) {
    review_listsCollection(filter: { id: { eq: $id } }, first: 1) {
      edges {
        node {
          ...FragReviewListItem
        }
      }
    }
  }
`;

export const REVIEW_LISTS = gql`
  ${FragReviewListItem}

  query ReviewLists($first: Int, $after: Cursor, $filter: review_listsFilter) {
    review_listsCollection(first: $first, after: $after, filter: $filter, orderBy: [{ created_at: DescNullsLast }]) {
      edges {
        node {
          ...FragReviewListItem
        }
        cursor
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
`;
